module.exports = __webpack_public_path__ + "img/edit-blue.703ffab0.svg";